import angular from 'angular'

import mySterileForm from './directives/forms/mySterileForm'
import mySterilesForm from './directives/forms/mySterilesForm'
import mySterilesEditForm from './directives/forms/mySterilesEditForm'

import sterileButtons from './resources/buttons.resource'
import sterileLabels from './resources/labels.resource'
import sterileFields from './resources/fields.resource'
import sterileIcons from './resources/icons.resource'

import sterileAsk from './services/ask.service'
import sterileFormat from './services/format.service'
import sterileGo from './services/go.service'
import sterileLocal from './services/local.service'
import sterileMetadata from './services/metadata.service'
import sterileRequest from './services/request.service'
import sterileResource from './services/resource.service'
import sterile from './services/sterile.service'

const name = 'sterile'
angular.module(name, [])
  .directive('mySterileForm', mySterileForm)
  .directive('mySterilesForm', mySterilesForm)
  .directive('mySterilesEditForm', mySterilesEditForm)

  .factory('sterileButtons', sterileButtons)
  .factory('sterileLabels', sterileLabels)
  .factory('sterileFields', sterileFields)
  .factory('sterileIcons', sterileIcons)

  .factory('sterileAsk', sterileAsk)
  .factory('sterileFormat', sterileFormat)
  .factory('sterileGo', sterileGo)
  .factory('sterileLocal', sterileLocal)
  .factory('sterileMetadata', sterileMetadata)
  .factory('sterileRequest', sterileRequest)
  .factory('sterileResource', sterileResource)
  .factory('$$sterile', sterile)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sterile/sterile.module.js